import { ref } from 'vue';
import { tools } from '@/utils/tools';
import CONFIG from '@/config/config';
export default function useXlTable(listFn, dataFilter) {
  const localPageSizeKey = CONFIG.prefix + 'tablePageSize';
  const psLocal = tools.getCookie(localPageSizeKey);
  const defaultProps = {
    'row-key': 'id',
    hoverable: true,
    // stripe: true,
    size: 'small',
    'column-resizable': true,
    loading: true,
    data: [],
    pagination: {
      current: 1,
      pageSize: psLocal ? Number(psLocal) : 10,
      total: 0,
      model: 1,
      showPageSize: true, // 是否显示数据条数选择器
      showJumper: true,
      pageSizeOptions: [10, 20, 30, 40, 50],
      showTotal: true // 是否显示数据总数
    },
    sortOrder: {
      dataIndex: '',
      sortOrder: ''
    }
  };
  const tProps = ref(defaultProps);
  // 分页
  const setPage = ({ current = 1, total }) => {
    if (tProps.value.pagination) {
      tProps.value.pagination.current = current;
      total && (tProps.value.pagination.total = total);
    }
  };
  // 加载效果
  const setTLoading = (status) => {
    tProps.value.loading = !!status;
  };
  // 设置额外属性
  const setTProps = (params) => {
    const par = params || {};
    for (const key in par) {
      // defaultProps[key] = params[key];
      if (key === 'pagination' && params[key]) {
        defaultProps[key] = { ...defaultProps[key], ...params[key] };
      } else {
        defaultProps[key] = params[key];
      }
    }
  };
  // 增加额外的列表参数
  const loadListParams = ref({});
  const setLoadListParams = (params) => {
    if (params) loadListParams.value = { ...loadListParams.value, ...params };
  };

  // 排序的默认参数
  const sortObj = ref({});

  // 加载分页列表数据
  const loadTList = async (page, loading) => {
    if (listFn) {
      try {
        let listData = [];
        if (loading !== false) {
          setTLoading(true);
        }
        const par = {
          // page_size: tProps.value?.pagination.pageSize,
          // model: tProps.value.pagination.model,
          // ...tProps.value.pagination,
          ...sortObj.value,
          ...loadListParams.value,
          page: page || tProps.value.pagination?.current,
          pageSize: tProps.value.pagination?.pageSize
        };
        tProps.value.sortOrder = {
          dataIndex: sortObj.value?.sortField ?? '',
          sortOrder: sortObj.value?.sortRule ? 'ascend' : 'descend'
        };
        const data = await listFn(par);
        const res = data.result || {};
        if (res?.records?.length) {
          listData = res?.records || [];
          setPage({ current: res?.current || 1, total: res?.total ?? res?.records?.length });
        } else {
          listData = [];
        }
        if (dataFilter) {
          listData = dataFilter(listData) || listData || [];
        }
        tProps.value.data = listData;
        setTLoading(false);
        return data;
      } catch (e) {
        if (e.code !== 'ERR_CANCELED') setTLoading(false);
        return [];
      }
    } else {
      setTLoading(false);
      return [];
    }
  };

  // 事件触发组
  const tPropsEvent = ref({
    //排序触发
    sorterChange: (dataIndex, direction) => {
      setPage({ current: 1 });
      let o = {};
      if (direction) {
        o = { sortField: dataIndex, sortRule: direction === 'ascend' ? true : false };
      }
      sortObj.value = o;
      loadTList();
    },
    //分页触发
    pageChange: (current) => {
      setPage({ current });
      loadTList();
    },
    // 修改每页显示条数
    pageSizeChange: (pageSize) => {
      tProps.value.pagination && (tProps.value.pagination.pageSize = pageSize);
      tools.setCookie(localPageSizeKey, pageSize <= 50 ? pageSize : 50, 365);
      loadTList();
    }
  });

  return {
    tProps,
    tPropsEvent,
    setTProps,
    setTLoading,
    setPage,
    setLoadListParams,
    sortObj,
    loadTList
  };
}
